import isMuiElement from'@mui/utils/isMuiElement';export default isMuiElement;